import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, RevealLineOnScroll } from "./Reveal";
import { BUSINESS_CAPABILITIES, EASE } from "../data";

export const Business = () => {
  return (
    <section
      id="business"
      data-testid="business-section"
      className="bg-[#f5f5f7] text-black py-16 md:py-24 border-t"
      style={{ borderColor: "var(--border-light)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[color:var(--primary-accent)] mb-6">
              For Enterprise
            </p>
          </Reveal>
          {/* <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.03]">
            <RevealLineOnScroll>Launch next-gen</RevealLineOnScroll>
            <RevealLineOnScroll delay={0.07}>crypto cards.</RevealLineOnScroll>
          </h2> */}
          <Reveal delay={0.2}>
            <p className="mt-8 text-lg text-black/60 max-w-md leading-relaxed">
              Launch next-generation crypto cards without building blockchain
              infrastructure. Focus on your customers.
            </p>
            <p className="mt-6 font-display text-2xl font-semibold">
              We&apos;ll handle the payments.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div
            className="grid sm:grid-cols-2 gap-px bg-[color:var(--border-light)] rounded-2xl overflow-hidden border"
            style={{ borderColor: "var(--border-light)" }}
          >
            {BUSINESS_CAPABILITIES.map((cap, i) => (
              <motion.div
                key={cap}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, ease: EASE, delay: i * 0.05 }}
                className="bg-white p-6 md:p-8 flex items-center justify-between group"
                data-testid={`business-capability-${i}`}
              >
                <span className="text-base md:text-lg font-medium">{cap}</span>
                <ArrowUpRight
                  size={18}
                  className="text-black/30 group-hover:text-[color:var(--primary-accent)] transition-colors duration-300"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
